import { render } from "./PlayerMatchMarkView.vue?vue&type=template&id=523fd557"
import script from "./PlayerMatchMarkView.vue?vue&type=script&lang=js"
export * from "./PlayerMatchMarkView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__